import React, { useState, useEffect } from "react"
import { Card } from "ui/Card"
import { Form, Input, Button, Flex } from "antd"
import { AddCategoryModal } from "../AddCategoryModal"
import { useTranslation } from "react-i18next"
import { MultipleSelect } from "ui/MultipleSelect"
import { useSelector } from "react-redux"
import { Icon } from "ui/Icon"
import PropTypes from "prop-types"
import { AiEnhancementModal } from "ui/AiEnhancementModal"
import { colors } from "themes/variables"
const { TextArea } = Input

export const ExperienceInfo = ({ form, onDescriptionChange }) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [showAiModal, setShowAiModal] = useState(false)
  const [descriptionValue, setDescriptionValue] = useState("")
  const [profileDescription, setProfileDescription] = useState("")
  const [t] = useTranslation()
  const categories = useSelector((state) => Object.values(state.trips.categories.data || {}))
  const { tripCategories } = useSelector((state) => state.trips)

  const showCategoryModal = () => {
    setIsModalVisible(true)
  }

  const handleClose = () => {
    setIsModalVisible(false)
  }
  useEffect(() => {
    form.setFieldsValue({ description: descriptionValue })
    onDescriptionChange?.()
  }, [descriptionValue, form])

  useEffect(() => {
    setDescriptionValue(form.getFieldValue("description") || "")
  }, [form.getFieldValue("description")])

  return (
    <>
      <Card title={t("experiences.details.experience_info")} className="mb-xl">
        <Form.Item name="categories" label="Category" rules={[{ required: true, message: "Please select at least one category" }]}>
          <MultipleSelect
            placeholder={t("experiences.details.select_category_placeholder")}
            options={tripCategories?.data?.categories}
            loading={categories?.loading}
          />
        </Form.Item>

        <div className="mb-m mt-xs sm:text-center">
          <span className="text-sm">
            {t("experiences.details.no_category_info")}{" "}
            <Button type="link" onClick={showCategoryModal} style={{ padding: 0 }}>
              {t("experiences.details.request_category")}
            </Button>
          </span>
        </div>

        <Form.Item name="title" label="Listing Title" rules={[{ required: true, message: t("experiences.details.listing_title_error") }]}>
          <Input placeholder={t("experiences.details.listing_title_placeholder")} />
        </Form.Item>

        <Flex justify="flex-end" className="mb-s">
          <Button
            type="primary"
            icon={
              <Icon
                name="aiEnhancement"
                color={descriptionValue.length < 25 ? colors.textPrimary : colors.disabled}
                height={20}
                width={20}
              />
            }
            onClick={() => setShowAiModal(true)}
            disabled={descriptionValue.length < 25}
          >
            {t("client.enhance_with_ui")}
          </Button>
        </Flex>

        <Form.Item
          name="description"
          label={t("global.description")}
          rules={[{ required: true, message: t("pro.ai_enhancement.description_too_short") }]}
        >
          <TextArea
            placeholder={t("experiences.details.description_placeholder")}
            rows={4}
            onChange={(e) => setDescriptionValue(e.target.value)}
            value={descriptionValue}
          />
        </Form.Item>
      </Card>

      <AddCategoryModal isVisible={isModalVisible} onCancel={handleClose} handleClose={handleClose} />
      {showAiModal && (
        <AiEnhancementModal
          open={showAiModal}
          description={descriptionValue}
          setDescription={setDescriptionValue}
          profileDescription={profileDescription}
          setProfileDescription={setProfileDescription}
          onOk={() => {
            setShowAiModal(false)
          }}
          onCancel={() => {
            setShowAiModal(false)
            setProfileDescription("")
          }}
          text={t("client.experience_content")}
          modalTitle={t("client.experiences_enhancer")}
          messages={t("pro.ai_enhancement.form.continue_refinement_info")}
          refinementTooltipTitle={t("client.refinement_tooltip")}
          improveWithAITooltipTitle={t("client.improve_with_ai_tooltip_for_experiences")}
        />
      )}
    </>
  )
}
ExperienceInfo.propTypes = {
  form: PropTypes.object,
  onDescriptionChange: PropTypes.func
}
